"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ACCESS_XXL = exports.ACCESS_OWNER = exports.ACCESS_FREE = exports.ACCESS_ANONYMOUS = void 0;
exports.getUserCSSClass = getUserCSSClass;
exports.isBeingBlocked = isBeingBlocked;
exports.isUserBlocked = isUserBlocked;
var ACCESS_ANONYMOUS = exports.ACCESS_ANONYMOUS = -1;
var ACCESS_FREE = exports.ACCESS_FREE = 0;
var ACCESS_XL = 1;
var ACCESS_XXL = exports.ACCESS_XXL = 2;
var ACCESS_GM = 3;
var ACCESS_TGM = 4;
var ACCESS_ADMIN = 5;
var ACCESS_OWNER = exports.ACCESS_OWNER = 6;
function isAnonymous(user) {
  return ACCESS_ANONYMOUS === user.member_type || user.uid < 0;
}
function isFree(user) {
  return ACCESS_FREE === user.member_type;
}
function isXXL(user) {
  return ACCESS_XXL <= user.member_type;
}
function isAdmin(user) {
  return ACCESS_ADMIN <= user.member_type;
}
function isOwner(user) {
  return ACCESS_OWNER === user.member_type;
}
function isCertified(user) {
  return user.certified;
}
function isUserBlocked(me, user) {
  if (!user || !user.uid) return false;
  var blocklist = false;
  if (me.hasOwnProperty('private_data')) {
    blocklist = me.private_data.blocklist;
  }
  if (blocklist) {
    for (var index in blocklist) {
      if (blocklist[index] === user.uid) {
        return true;
      }
    }
  }
  return false;
}
function isBeingBlocked(currentUser, user) {
  if (!user || !user.uid) return false;
  var blocked_by = false;
  if (currentUser.hasOwnProperty('private_data')) {
    blocked_by = currentUser.private_data.blocked_by;
  }
  if (blocked_by) {
    for (var index in blocked_by) {
      if (blocked_by[index].uid === user.uid) return blocked_by[index];
    }
    return false;
  }
  return isUserBlocked(user, currentUser);
}
function getUserCSSClass(me, recipient) {
  var cssClasses = [];
  var gender = recipient.gender;
  if (gender == 1) {
    cssClasses.push('male');
  }
  if (gender == 2) {
    cssClasses.push('female');
  }
  if (gender == 3) {
    cssClasses.push('couple');
  }
  if (gender == 4) {
    cssClasses.push('trans');
  }
  if (isAnonymous(recipient)) {
    if (isOwner(me)) {
      cssClasses.push('anonymous-alt');
    } else {
      cssClasses.push('anonymous');
    }
  }
  if (!isCertified(recipient)) {
    cssClasses.push('uncertified');
  }
  var giftRank = recipient.gift_rank;
  if (giftRank) {
    cssClasses.push('rank-' + giftRank);
  }
  if (isUserBlocked(me, recipient)) {
    cssClasses.push('blocked');
  }
  return cssClasses.join(' ');
}